// CookiesConsent.tsx
import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import { cookies } from '../cookies';
import { useTranslation } from 'react-i18next';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

export default function CookiesConsent() {

    const [open, setOpen] = React.useState<boolean>(false);
    const { t } = useTranslation();

    const handleAccept = () => {
        // Set a cookie to expire in 1 days
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 1); // Add 7 days to the current date
        cookies.set(COOKIE_CONSENT_KEY, 'true', { expires: futureDate });
        setOpen(false);
    }

    React.useEffect(() => {
        console.log('check cookies');
        const consent = cookies.get(COOKIE_CONSENT_KEY);
        if (!consent) {
            setOpen(true);
        }
    }, []);

    return (
        <Dialog open={open}
                aria-labelledby="cookie-consent-title"
                aria-describedby="cookie-consent-description" >
            <DialogContent>
                <DialogContentText id="cookie-consent-description">
                    {t('cookies.consent.1')}
                </DialogContentText>
                <DialogContentText id="cookie-consent-description2">
                    {t('cookies.consent.2')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAccept}
                        variant="outlined"
                        color="secondary"
                        size="large"
                        style={{ width: '200px'}}>
                    {t('cookies.consent.accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
